import { createContext, useState } from 'react';
import ActivityCard from '../profile/ActivityCard';

const PostContext= createContext();

export const PostProvider = ({children}) => {

    /*  Activities: Study, Eat, Exercise, Hangout, Party, School Event

        North Campus Locations: Alfiero Center, Alumni Arena, Baird Hall, Baird Research Park, Baker Chilled Water Plant, Baldy Hall, 
        Beane Service Center, Bell Hall, Bissell Hall, Bonner Hall, Bookstore, Campus Mail Center, Capen Hall, Center for the Arts,
        Center for Tomorrow, Child Care Center, Clemens Hall, Commons, Computing Center, Cooke Hall, Creekside Village, Crofts Hall,
        Davis Hall, Dorsheimer Laboratory/Greenhouse, Ellicott Complex, Flickinger Court, Flint Village, Fronczak Hall, Furnas Hall,
        Governors Residence Halls, Lehman Hall, Clinton Hall, Dewey Hall, Roosevelt Hall, Greiner Hall, GRoW Home, Hadley Village, 
        Helm Warehouse, HRD Building, Hochstetter Hall, Jacobs Management Center, Jarvis Hall, Ketter Hall, Knox Lecture Hall, 
        Lockwood Library, Mathematics Building, Morris Sports Performance Center, Murchie Family Fieldhouse, Natural Sciences Complex,
        Norton Hall, O’Brian Hall, Park Hall, Slee Hall, South Lake Village, Stadium, Statler Food Commissary, Student Union,
        Talbert Hall, Visitor Information Booth, Ellicott Complex, Fargo Quadrangle, Evans Quadrangle, Red Jacket Quadrangle,
        Richmond Quadrangle, Spaulding Quadrangle, Wilkeson Quadrangle, Academic Center, Katharine Cornell Theatre,  Albert P. Sy Lecture Hall,
        C3 Crossroads Culinary Center

        South Campus Location: Abbott Hall, Acheson Annex, Allen Hall, Beck Hall, Biomedical Education Building, Biomedical Research Building,
        Cary Hall, Child Care Center, Clark Hall, Clement Hall, Crosby Hall, Diefendorf Hall, Farber Annex, Farber Hall, Foster Hall, 
        Goodyear Hall, Harriman Hall, Hayes A, NFTA University Station, Parker Hall, Pharmacy Building, Service Building (220 Winspear),
        Service Center (250 Winspear), Service Garage Building, Sherman Annex, Sherman Hall, Squire Hall, Townsend Hall, Wende Hall, 
        Hayes B, Hayes C, Hayes D, Hayes Hall, Howe Research Building, Kimball Tower, Mackay Heating Plant, Michael Hall

    */

    // stores information of a post
    const [postData,setPostData] = useState({
        activity: '',
        location: '',
        date: '',
        end_day:'',
        start: '',
        end: '',
        privacy: ''
    })

    // variable to track modal popup 
    const [showPost, setShowPost] = useState(false)

    return <PostContext.Provider 
    value = {{
        postData,
        setPostData,
        showPost,
        setShowPost, 
     }}>
        {children}
     </PostContext.Provider>
}

export default PostContext